<template>
  <div class="gift_customization___wrap">
    <Breadcrumb :config="breadcrumb" />
    <ImageTextAnimate :config="config" />
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import ImageTextAnimate from '@/components/ImageTextAnimate';
import GiftCustomizationImage from '@/assets/imgs/GiftCustomization.jpg';

export default {
  name: "GiftCustomization",
  components: { Breadcrumb, ImageTextAnimate },
  data() {
    return {
      breadcrumb: {
        items: [{ text: "礼品定制", href: "" }]
      },
      config: {
        title: "奢宠礼遇",
        subtitle: "",
        desc: `在希思黎，我们关注每一个订单的配送体验。
          精美包装
          Sisley法国希思黎中国官方网站及小程序官方商城的每一个订单都将以精美的礼盒包装快递给您，尊享官网独家购物体验，是您礼献挚爱的倾情之选。

          定制化礼品卡
          如果您在Sisley法国希思黎官网及小程序官方商城上购买的Sisley产品有送礼的需求，您可以在提交订单时添加礼品卡信息。我们会将其写打印在礼品卡上并将其放置在包裹中。

          提交送礼地址
          您可以在订单中添加送礼地址，我们会直接将产品寄送至收礼人。`,
        src: GiftCustomizationImage
      }
    };
  }
}
</script>

<style lang="scss" scoped>
  @media screen and (min-width: 64em) {
    .gift_customization___wrap /deep/ .breadcrumb { padding: 0 1.875rem; }
  }
</style>